import { render, staticRenderFns } from "./user_invoice_list.vue?vue&type=template&id=0096536e&"
import script from "./user_invoice_list.vue?vue&type=script&lang=js&"
export * from "./user_invoice_list.vue?vue&type=script&lang=js&"
import style0 from "./user_invoice_list.vue?vue&type=style&index=0&id=0096536e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports